import { TbBuilding, TbNut } from "react-icons/tb";

import { IHotelClinicPassengerType } from "@/models/hotel-clinic.model";
import { CommonStatusItem } from "@/types/global";

import { softColors } from "./colors";

export type ClinicArrivalPassengerTypeItem = CommonStatusItem & {
    label: string;
    value: IHotelClinicPassengerType;
};

export type ClinicArrivalPassengerTypeList = ClinicArrivalPassengerTypeItem[];

export const clinicArrivalPassengerTypes: ClinicArrivalPassengerTypeList = [
    {
        label: "Klinik Sistemi",
        value: IHotelClinicPassengerType.CLINIC,
        component: () => TbBuilding,
        ...softColors.green,
        tooltip: {
            title: "Klinik Yolcusu",
            description: "Yolcu klinik listesinden otomatik olarak sisteme eklenmiştir.",
        },
    },
    {
        label: "Transfer İsteği",
        value: IHotelClinicPassengerType.CUSTOM,
        component: () => TbNut,
        ...softColors.indigo,
        tooltip: {
            title: "Manuel Yolcu",
            description: "Transfer isteği ile sisteme eklenmiştir.",
        },
    },
];
